import { render } from "./HoverableDropdown.vue?vue&type=template&id=8521c5d2&scoped=true"
import script from "./HoverableDropdown.vue?vue&type=script&lang=js"
export * from "./HoverableDropdown.vue?vue&type=script&lang=js"

import "./HoverableDropdown.vue?vue&type=style&index=0&id=8521c5d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8521c5d2"]])

export default __exports__